'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Script from 'next/script'
// import AuthProvider from './Auth'
import '@/lib/i18n'

const Providers = ({ children }: { children: React.ReactNode }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: false,
            refetchOnWindowFocus: false,
          },
        },
      }),
  )

  const pathname = usePathname()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  const amplitudeKey = process.env.NEXT_PUBLIC_AMPLITUDE_KEY

  return (
    <>
      {process.env.NODE_ENV === 'production' && (
        <Script
          src={`https://cdn.amplitude.com/script/${amplitudeKey}.js`}
          strategy="afterInteractive"
          onLoad={() => {
            const w = window as any
            try {
              // w?.amplitude?.add(w?.sessionReplay?.plugin?.({ sampleRate: 1 }))
              w?.amplitude?.init(amplitudeKey, {
                fetchRemoteConfig: true,
                autocapture: {
                  attribution: true,
                  fileDownloads: true,
                  formInteractions: true,
                  pageViews: true,
                  sessions: true,
                  elementInteractions: true,
                  networkTracking: true,
                  webVitals: true,
                  frustrationInteractions: true,
                },
              })
            } catch (e) {
              // silent fail
            }
          }}
        />
      )}
      <QueryClientProvider client={queryClient}>
        {children}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  )
}

export default Providers
